export default __webpack_public_path__ + "static/media/img4.0e292c5e.png";